import { httpMethod, useApi } from './useApi';
export const useQueryDocument = () => {
    const { call, data, ...rest } = useApi({
        authenticated: true,
        version: 2,
        path: 'documents/query',
        httpMethod: httpMethod.POST,
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, ...rest };
};
export const usePutQuery = () => {
    const { call, data, ...rest } = useApi({
        authenticated: true,
        version: 1,
        path: 'documents/queries',
        httpMethod: httpMethod.PUT,
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, ...rest };
};
